import { render, staticRenderFns } from "./AffiliateDialog.vue?vue&type=template&id=4f627f41&scoped=true&"
import script from "./AffiliateDialog.vue?vue&type=script&lang=ts&"
export * from "./AffiliateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AffiliateDialog.vue?vue&type=style&index=0&id=4f627f41&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f627f41",
  null
  
)

export default component.exports